import { getImageUrl } from "../../../../../helpers/PB";

const PreviewExportConfig = {
  collection: "preview_export",
  single: true,
  fields: [
    "id",
    "date_updated",
    "preview_report_label",
    "export_options_label",
    "template_label",
    "full_version_label",
    "simplified_version_label",
    "export_pdf_label",
    "negative_savings_message",
    "missing_data_message",
    "export_pdf_icon.id" //not needed
  ],

  adapter: class PreviewExport {
    constructor(previewExport) {
      Object.assign(this, previewExport);
      this.export_pdf_icon = getImageUrl(previewExport?.export_pdf_icon?.id);
    }
  }
};

export default PreviewExportConfig;
